/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useLazyQuery } from '@apollo/client';
// import { sharingValidationSchema } from 'pages/OfferCoupons/constants';
import { SEND_COUPONS_TO_TRADER } from 'pages/OfferCoupons/CouponGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ShareCouponCodeForm from './components/ShareCouponCodeForm';

const ShareCouponCode = ({ onCloseUpdatePopup, currentRow }) => {
  const [sendCouponsToTraderOverEmail] = useLazyQuery(SEND_COUPONS_TO_TRADER, {
    fetchPolicy: 'network-only',
  });

  const handleSubmit = async (values) => {
    try {
      const res = await sendCouponsToTraderOverEmail({
        variables: {
          couponId: currentRow?.id,
          traders: values?.vendor?.map((item) => item?.id),
        },
      });
      if (res?.data?.sendCouponsToTraderOverEmail) {
        toast.success(res?.data?.sendCouponsToTraderOverEmail);
        onCloseUpdatePopup();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const sharingValidationSchema = Yup.object().shape({
    vendor: Yup.array()
      .min(1, 'Select at least one trader')
      .max(
        currentRow?.usageLimit - currentRow?.usageCount,
        `Select up to ${currentRow?.usageLimit - currentRow?.usageCount} trader`,
      )
      .required('Select at least one trader'),
  });

  return (
    <ErrorBoundary>
      <Formik
        // validateOnChange={false}
        // validateOnBlur={false}
        enableReinitialize
        initialValues={{ vendor: [], countryType: 'indian' }}
        onSubmit={handleSubmit}
        validationSchema={sharingValidationSchema}
        children={(props) => {
          return (
            <ShareCouponCodeForm
              onCloseUpdatePopup={onCloseUpdatePopup}
              {...props}
            />
          );
        }}
      />
    </ErrorBoundary>
  );
};

export default ShareCouponCode;
